import { Card, Collapse, Group, Text, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { ReactNode, useState } from 'react';

type ExpandableCardProps = {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  action?: ReactNode;
};

export function ExpandableCard({ title, children, defaultExpanded = true, action }: ExpandableCardProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Card p={0}>
      <UnstyledButton onClick={() => setExpanded((prev) => !prev)} w="100%" p="md" style={{ cursor: 'pointer' }}>
        <Group gap="xs" wrap="nowrap" justify="space-between" w="100%">
          <Group gap="xs" wrap="nowrap">
            <IconChevronRight
              size={16}
              style={{
                transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s',
              }}
            />
            <Text size="md" fw={600} c="gray">
              {title}
            </Text>
          </Group>
          {action && <div onClick={(e) => e.stopPropagation()}>{action}</div>}
        </Group>
      </UnstyledButton>
      <Collapse in={expanded}>
        <div style={{ padding: '0 16px 16px 16px' }}>{children}</div>
      </Collapse>
    </Card>
  );
}
